import axios from "./axios"; // Import the centralized Axios instance

const state = {
  image: [],
};

const getters = {
  allImages: (state) => state.image,
};

const actions = {
  async upload({ commit }, image) {
    try {
      commit("resetImages");
      const response = await axios.post("/upload/image-upload", image);
      commit("setImages", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch images:", error);
    }
  },
};

const mutations = {
  setImages(state, images) {
    state.images = images.data; // Ensure this matches your API's response structure
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
